<template>
  <div id="app">
    <!-- INTERFACE AUTENTICADA -->
    <template v-if="isAuthenticated">
      <!-- HEADER FIXO -->
      <Header class="app-header-fixed" />
      
      <!-- CONTAINER PRINCIPAL -->
      <div class="app-container">
        <!-- SIDEBAR FIXA -->
        <Sidebar class="app-sidebar-fixed" />
        
        <!-- ÁREA DE CONTEÚDO -->
        <div class="app-content-area">
          <!-- BREADCRUMB FIXO -->
          <div class="app-breadcrumb-bar">
            <Breadcrumb :custom-titles="customTitles" />
          </div>
          
          <!-- CONTEÚDO SCROLLÁVEL -->
          <main class="app-main-content">
            <router-view />
          </main>
        </div>
      </div>
    </template>
    
    <!-- INTERFACE NÃO AUTENTICADA - APENAS LOGIN -->
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useBreadcrumbTitle } from '@/composables/useBreadcrumbTitle'
import Header from '@/components/common/Header.vue'
import Sidebar from '@/components/common/Sidebar.vue'
import Breadcrumb from '@/components/common/Breadcrumb.vue'

const authStore = useAuthStore()
const { customTitles } = useBreadcrumbTitle()

// Computed reativo para garantir atualização imediata da interface
const isAuthenticated = computed(() => authStore.isAuthenticated)

onMounted(() => {
  // Tentar restaurar sessão salva
  authStore.initializeAuth()
})
</script>

<style src="./assets/main.css"></style>